import { NavLink, useLocation } from 'react-router-dom';
import Logo from './Logo';
import Button from './Button';
import ThemeToggle from './ThemeToggle';

const links = [
  { to: '/home', label: 'Product' },
  { to: '/auth', label: 'Auth' },
  { to: '/dashboard', label: 'Dashboard' },
  { to: '#', label: 'Docs' },
  { to: '#', label: 'Pricing' },
  { to: '#', label: 'Changelog' },
  { to: '#', label: 'Blog' },
];

export default function Nav() {
  const { pathname } = useLocation();
  return (
    <header className="sticky top-0 z-40 border-b border-border bg-page/75 backdrop-blur-xl">
      <div className="mx-auto flex h-[72px] w-full max-w-[1440px] items-center justify-between px-6 lg:px-8">
        <div className="flex items-center gap-3">
          <Logo />
          <span className="inline-flex items-center rounded-full border border-pink/40 bg-pinkSoft px-2 py-0.5 text-[10px] font-bold tracking-wider text-pinkMid">
            BETA
          </span>
        </div>

        <nav className="hidden items-center gap-6 md:flex">
          {links.map(l => {
            const active =
              (l.to === '/' && pathname === '/') ||
              (l.to !== '/' && l.to !== '#' && pathname.startsWith(l.to));
            return (
              <NavLink
                key={l.label}
                to={l.to}
                className={`text-[14px] transition-colors ${
                  active ? 'text-violet font-semibold' : 'text-body hover:text-ink'
                }`}
              >
                {l.label}
              </NavLink>
            );
          })}
        </nav>

        <div className="flex items-center gap-2">
          <a href="#" className="mr-2 hidden text-[14px] text-body hover:text-ink md:inline">
            Sign in
          </a>
          <ThemeToggle />
          <Button variant="dark" size="md">
            Get started <span aria-hidden>→</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
